const useEventTypeImages = ({ setEventTypeForm, imageDrafts }) => {
  const handleEventTypeImageSelect = (files) => {
    const selected = Array.from(files || []);
    if (selected.length === 0) return;

    const existing = Array.isArray(imageDrafts) ? imageDrafts : [];
    const existingCount = existing.length;
    const totalCount = existingCount + selected.length;
    if (totalCount > 10) {
      alert('이미지는 최대 10장까지 업로드할 수 있습니다.');
      return;
    }

    const nextDrafts = selected.map((file, idx) => ({
      id: `${Date.now()}-${idx}-${file?.name || 'image'}`,
      file,
      previewUrl: URL.createObjectURL(file),
    }));

    setEventTypeForm((p) => ({
      ...(p || {}),
      imageDrafts: [...existing, ...nextDrafts],
      coverDraftId: p?.coverDraftId || nextDrafts?.[0]?.id || '',
    }));
  };

  const handleRemoveEventTypeImage = (id) => {
    setEventTypeForm((p) => {
      const drafts = Array.isArray(p?.imageDrafts) ? p.imageDrafts : [];
      const nextDrafts = drafts.filter((d) => d.id !== id);
      const nextCover = p?.coverDraftId === id ? nextDrafts[0]?.id || '' : p?.coverDraftId;
      return {
        ...(p || {}),
        imageDrafts: nextDrafts,
        coverDraftId: nextCover,
      };
    });
  };

  const handleSelectEventTypeCover = (id) => {
    setEventTypeForm((p) => ({ ...(p || {}), coverDraftId: id }));
  };

  return {
    handleEventTypeImageSelect,
    handleRemoveEventTypeImage,
    handleSelectEventTypeCover,
  };
};

export default useEventTypeImages;
